import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { createTheme, ThemeProvider, useMediaQuery } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AppDialog({
  show,
  onChangeShow = (val) => { },
  showClose = true,
  children,
  bgColor,
  ...props
}) {
  const theme = createTheme({
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            background:
              bgColor ||
              "linear-gradient(193.68deg, #003B6A -6.28%, #021024 101.79%)",
          },
        },
      },
    },
  });
  const [open, setOpen] = React.useState(false);
  const isBigScreen = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  React.useEffect(() => {
    setOpen(show);
  }, [show]);

  const handleClose = (_, reason) => {
    if (reason && reason === "backdropClick") {
      return;
    }
    setOpen(false);
    onChangeShow(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        fullScreen={isBigScreen}
        open={open}
        sx={{
          height: isBigScreen ? "auto" : "100%",
        }}
        onClose={handleClose}
        TransitionComponent={Transition}
        {...props}
      >
        {!!showClose && (
          <AppBar
            position="fixed"
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
              height: "3.6rem",
            }}
          >
            <Toolbar sx={{ display: "flex", justifyContent: "flex-end" }}>
              <IconButton
                edge="end"
                color="inherit"
                aria-label="tracker"
                aria-describedby="close_icon_click"
                onClick={handleClose}
              >
                <CloseIcon htmlColor="#F8FAFF" aria-label="tracker"
                  aria-describedby="close_icon_click" />
              </IconButton>
            </Toolbar>
          </AppBar>
        )}
        {children}
      </Dialog>
    </ThemeProvider>
  );
}
